import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '../../utils/cn';
import { inputClass } from './Input';

/**
 * Native HTML <select> wrapped in shadcn styling.
 * Light + fast: no Radix portal, no popper layout — uses the OS chooser.
 */
export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, children, ...props }, ref) => (
    <select ref={ref} className={cn(inputClass, className)} {...props}>
      {children}
    </select>
  )
);
Select.displayName = 'Select';
